import { render, staticRenderFns } from "./BaseCustomerSelect.vue?vue&type=template&id=2af9c582&"
import script from "./BaseCustomerSelect.vue?vue&type=script&lang=js&"
export * from "./BaseCustomerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af9c582')) {
      api.createRecord('2af9c582', component.options)
    } else {
      api.reload('2af9c582', component.options)
    }
    module.hot.accept("./BaseCustomerSelect.vue?vue&type=template&id=2af9c582&", function () {
      api.rerender('2af9c582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/BaseCustomerSelect.vue"
export default component.exports